export default function DraftWatermark() {
  return (
    <div className="absolute inset-0 pointer-events-none select-none overflow-hidden z-100 flex items-center justify-center">
      <div className="whitespace-nowrap opacity-10 text-[8rem] leading-none -rotate-45 origin-center flex flex-col items-center justify-center border-dashed border-10">
        <h1 className="text-10xl">Draft Report</h1>
        <p className="text-6xl">Only for previewing</p>
      </div>
    </div>
  )
}
